class McModal extends McBase {
    constructor(){
        super();
    }

    connectedCallback(){
        this.modal = this.querySelector('.modal');
        if(this.dataset.preventoobclose == null){
            this.addEventListener('click', () => {
                this.close();
            })
            this.modal.addEventListener('click', (e) => {
                e.stopPropagation();
            })
        }        
    }
}

if(!window.customElements.get('mc-modal')){
    window.customElements.define('mc-modal', McModal);
}
window.McModal = McModal;